import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/component/home/gallery.css';
import axios from 'axios';

function GallerySlider() {
    const [newProducts, setNewProducts] = useState([]);
    const [moreBuy, setMoreBuy] = useState([]);
    const [startIndex1, setStartIndex1] = useState(0);
    const [startIndex2, setStartIndex2] = useState(0);
    const visibleCount = 5;

    // 1. Neue Produkte laden
    useEffect(() => {
        axios.get('https://nurleder.de/api/newProduct/')
            .then(res => {
                setNewProducts(res.data.filter(item => item.image));
            })
            .catch(err => {
                console.error("❌ Fehler beim Laden von newProduct:", err);
            });
    }, []);




    // 2. MoreBuy-Produkte laden
    useEffect(() => {
        axios.get('https://nurleder.de/api/moreBuy/')
            .then(res => {
                setMoreBuy(res.data.filter(item => item.image));
            })
            .catch(err => {
                console.error("❌ Fehler beim Laden von moreBuy:", err);
            });
    }, []);


    const visibleItems1 = newProducts.slice(startIndex1, startIndex1 + visibleCount);
    const visibleItems2 = moreBuy.slice(startIndex2, startIndex2 + visibleCount);

    return (
        <div>
            {/* Erste Reihe: neue Produkte */}
            <div className="gallery-section">
                <div className="gallery-header">
                    <div className="nav-buttons">
                        <button onClick={() => startIndex1 > 0 && setStartIndex1(startIndex1 - 1)}>❮</button>

                    </div>
                    <h3>🧵 Frisch gefertigt</h3>
                    <div className="nav-buttons">

                        <button onClick={() => startIndex1 + visibleCount < newProducts.length && setStartIndex1(startIndex1 + 1)}>mehr ❯</button>
                    </div>

                </div>

                <div className="gallery-row">
                    {visibleItems1.map((item, index) => (
                        <div className="gallery-item" key={index}>
                            <img src={item.image} alt={item.name} />
                            <Link to={`/products/${item.category}`} className="gallery-caption">
                                {item.name}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>

            {/* Zweite Reihe: Kundenlieblinge */}
            <div className="gallery-section">
                <div className="gallery-header">
                    <div className="nav-buttons">
                        <button onClick={() => startIndex2 > 0 && setStartIndex2(startIndex2 - 1)}>❮</button>
                    </div>
                    <h3>🌟 Kundenlieblinge</h3>
                    <div className="nav-buttons">
                        <button onClick={() => startIndex2 + visibleCount < moreBuy.length && setStartIndex2(startIndex2 + 1)}>mehr ❯</button>
                    </div>
                </div>

                <div className="gallery-row">
                    {visibleItems2.map((item, index) => (
                        <div className="gallery-item" key={index}>
                            <img src={item.image} alt={item.name} />
                            <Link to={`/products/${item.category}`} className="gallery-caption">
                                {item.name}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div >
    );
}

export default GallerySlider;
